import { ConnectorServiceEnum } from '@enum/connector-service.enum';
import { FieldInterface } from '@interface/form/base-form.interface';

export const getIntegrationFields = (serviceId: ConnectorServiceEnum): FieldInterface[] => {
  switch (serviceId) {
    case ConnectorServiceEnum.BambooHR:
    case ConnectorServiceEnum.Hexnode:
      return [
        {
          label: 'Domain',
          name: ['settings', 'domain'],
          placeholder: 'Please input domain',
        },
        {
          label: 'Api Key',
          name: ['settings', 'apiKey'],
          placeholder: 'Please input apiKey',
        },
      ];
    case ConnectorServiceEnum.Jamf:
      return [
        {
          label: 'Instance',
          name: ['settings', 'instance'],
          placeholder: 'Please input instance name',
        },
        {
          label: 'Username',
          name: ['settings', 'username'],
          placeholder: 'Please input username',
        },
        {
          label: 'Password',
          name: ['settings', 'password'],
          placeholder: 'Please input password',
          type: 'password',
        },
      ];
    case ConnectorServiceEnum.Teamtailor:
    case ConnectorServiceEnum.Inrego:
      return [
        {
          label: 'API Key',
          name: ['settings', 'apiKey'],
          placeholder: 'Please input API Key',
        },
      ];
    case ConnectorServiceEnum.Velory:
      return [
        {
          label: 'Email',
          name: ['settings', 'email'],
          placeholder: 'Please input email',
        },
        {
          label: 'Password',
          name: ['settings', 'password'],
          placeholder: 'Please input password',
          type: 'password',
        },
        {
          label: 'Domain',
          name: ['settings', 'domain'],
          placeholder: 'Please input domain',
          type: 'velory',
        },
      ];
    case ConnectorServiceEnum.Postnord:
      return [
        {
          label: 'API Key',
          name: ['settings', 'apiKey'],
          placeholder: 'Please input API Key',
        },
      ];
    case ConnectorServiceEnum.Bring:
      return [
        {
          label: 'Login',
          name: ['settings', 'login'],
          placeholder: 'Please input login',
        },
        {
          label: 'API Key',
          name: ['settings', 'apiKey'],
          placeholder: 'Please input API Key',
        },
      ];
    case ConnectorServiceEnum.Fedex:
      return [
        {
          label: 'Client ID',
          name: ['settings', 'clientId'],
          placeholder: 'Please input client ID',
        },
        {
          label: 'Client secret',
          name: ['settings', 'clientSecret'],
          placeholder: 'Please input client secret',
        },
      ];
    case ConnectorServiceEnum.Hibob:
      return [
        {
          label: 'Service User ID',
          name: ['settings', 'serviceUserId'],
          placeholder: 'Please input service user ID',
        },
        {
          label: 'Service token',
          name: ['settings', 'serviceUserToken'],
          placeholder: 'Please input service token',
        },
      ];
    case ConnectorServiceEnum.Posti:
      return [
        {
          label: 'API Key',
          name: ['settings', 'apiKey'],
          placeholder: 'Please input API Key',
        },
        {
          label: 'API Secret',
          name: ['settings', 'apiSecret'],
          placeholder: 'Please input API Secret',
        },
      ];
    case ConnectorServiceEnum.Deel:
    case ConnectorServiceEnum.HaileyHR:
      return [
        {
          label: 'Access Token',
          name: ['settings', 'accessToken'],
          placeholder: 'Please input Access Token',
        },
      ];
    case ConnectorServiceEnum.Netset:
    case ConnectorServiceEnum.Webmercs:
      return [
        {
          label: 'Domain',
          name: ['settings', 'domain'],
          placeholder: 'Please input domain',
        },
        {
          label: 'Customer Numbers',
          name: ['settings', 'customerNumber'],
          placeholder: 'Please input customer number',
        },
        {
          label: 'Username',
          name: ['settings', 'username'],
          placeholder: 'Please input username',
        },
        {
          label: 'Password',
          name: ['settings', 'password'],
          placeholder: 'Please input password',
          type: 'password',
        },
      ];
    default:
      return [];
  }
};
